import { render } from "./GoToCheckoutModal.vue?vue&type=template&id=87d4eb92"
import script from "./GoToCheckoutModal.vue?vue&type=script&lang=js"
export * from "./GoToCheckoutModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__